import { useToast } from './useToast';

// Safe toast hook that doesn't crash if ToastProvider isn't available
export function useSafeToast() {
  try {
    return useToast();
  } catch {
    // If useToast throws (no ToastProvider), return a no-op implementation
    console.warn('useSafeToast: ToastProvider not available, using no-op implementation');
    return {
      toast: () => {},
      dismiss: () => {},
      toasts: [],
    };
  }
}
